import { ModalContentWrapper } from "components/ModalContentWrapper";
import { TextInput } from "components/TextInput";
import { FC } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface NaturvardsverketContactFormData {
  nvContactFullName: string;
  nvContactEmail: string;
  nvContactPhone: string;
}

interface Props {
  register: UseFormRegister<NaturvardsverketContactFormData>;
  errors: FieldErrors<NaturvardsverketContactFormData>;
}

export const NaturvardsverketContactModal: FC<Props> = ({
  register,
  errors,
}) => {
  return (
    <ModalContentWrapper>
      <div className="mb-8 space-y-8">
        <TextInput
          label="Kontaktperson"
          name="nvContactFullName"
          register={register}
          errorMessage={errors?.nvContactFullName?.message}
        />
        <TextInput
          label="E-postadress"
          name="nvContactEmail"
          register={register}
          errorMessage={errors?.nvContactEmail?.message}
        />
        <TextInput
          label="Telefonnummer"
          name="nvContactPhone"
          register={register}
          errorMessage={errors?.nvContactPhone?.message}
        />
      </div>
    </ModalContentWrapper>
  );
};

export type { NaturvardsverketContactFormData };
